<template>
    <div class="Page">
        <section>
            <v-row class="banner">
                <v-col class="d-flex align-center "> <div class="padOpportunities"><h1 class="sectionTitle" style="">Nos Fournisseurs</h1></div> </v-col> 
            </v-row>
        </section>
        <!--JobsList-->
        <section>
            <v-row class="JobsListBg ">
                <v-col v-for="(item,i) in this.Suppliers" :key="i" class="career-box">
                    <a :href="item.link" target="_Blank" style="height: 100%; width: 100%;">
                        <v-col class="card dealerFront" style="">
                            <h2 class="career-box-Title sectionTitle">{{ item.title }}</h2>
                        </v-col>
                    </a>                
                </v-col>
            </v-row>
        </section>
        <!--newsletters-->
        <section>
            <div class="orangeStripe"></div>
                <v-row class="bgBlack">
                    <v-col cols="12" md="6" class="textAlignement">
                        <h2 class="sectionTitle">RESTEZ INFORMÉ(E)S&nbsp;!</h2>
                        <p class="sectionSubtitle spaceNewsletter">Abonnez-vous à notre infolettre du Réseau Dynamique pour recevoir les premiers nos promotions, événements, du contenu exclusif&nbsp;et&nbsp;plus&nbsp;encore&nbsp;!</p>
                        <a href="https://app.cyberimpact.com/clients/47814/subscribe-forms/8F9576B8-21A3-49D4-9B9C-DA19428BAE27" target="_Blank"><button style="" class="priBtn spaceNewsletter">S’inscrire</button></a>
                    </v-col>
                    <v-col class="">
                    </v-col>
            </v-row>
        </section>
    </div>
  </template>
  <style scoped>
        .padOpportunities { padding: 0px 100px; }
        .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/career/bannerOpportunities.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
        .jobBg { padding: 50px 100px; background-color: black; }
        .jobTitle {color: rgb(var(--secondary)); text-transform: uppercase; font-family: TxtOffBDI; font-size: 28px; }
        .jobText { color: white; margin-top: 20px; }

        .JobsListBg { min-height: 1000px; background-color: rgb(var(--ligthGray)); padding: 50px; } 
        .career-box {  position: relative; max-width: 700px; min-width: 700px; width: 700px; min-height: 100px; margin: 20px auto; perspective: 1000px;  }
        .career-box-Title { text-transform: uppercase; width: 100%; text-align: center; color: white; position: absolute; top:50%; left: 50%; transform: translate(-50%,-50%); font-family: TxtOffBDI; z-index: 100; }
        .career-box-Town { text-transform: uppercase; display: inline-block; width: 100%; text-align: center; color: white; font-family: TxtOffBDI;}
        .career-box-Town:hover { cursor: pointer; color: rgb(var(--primary));}
        .career-box:hover { cursor: pointer; }
        .career-box:hover .career-box-Title { color: rgb(var(--primary));  }
        .career-box img {position: relative; z-index: 10; width: 100%; height: 100%; object-fit: cover; object-position: center center; box-shadow: 0px 5px 10px 0px black; }
        .career-box-Shaddow { position: absolute; top:0px; z-index: 1; height: 700px; width: 800px; background-color: rgba(var(--black),0.5); margin: 50px auto; border-radius: 0% 0% 30% 30% / 0% 0% 30% 30%; }

        .card { width: 100%; height: 100%; position: absolute; backface-visibility: hidden; transition: transform 0.6s; background-color: black;  }

        /*#region newsletter*/
        .bgNewsletter { display: block; background-image: url('../../public/ressources/images/home/infolettre.png'); background-position: center center; background-size: cover; background-repeat: no-repeat; }
        .bgBlack {background-color: black; }
        .textAlignement {padding: 2% 5% !important;}
        .spaceNewsletter { margin: 20px 0px; }
        /*#endregion*/
        @media handheld, only screen and (max-width: 600px) {
            .career-box { max-width: 100%; min-width: 100% !important; margin: 20px auto; }
            .career-box-Title { font-size: 18px; }
        }
        @media handheld, only screen and (max-width: 960px) {
            .career-box { min-height: 100px; max-width: 100% !important; min-width: 100% !important; margin: 20px auto; }
        }
        @media handheld, only screen and (max-width: 1279px) {}
        @media handheld, only screen and (max-width: 1378px) {}
  </style>
  <script>
  
  export default {
    name: 'opportunities',
    data:()=>({
        Suppliers:null,

    }),
    async mounted() {
        await this.suppliersJsonRead();

    },
    methods:{
        suppliersJsonRead: async function () {
            try {
                const response = await fetch('/ressources/json/Suppliers.json');
                if (!response.ok) {
                    throw new Error('Failed to fetch');
                }
                this.Suppliers = await response.json();

            } catch (error) {
                console.error('Error loading JSON data:', error);
            }
        },
    },
    components: { }
  }
  </script>
  